<!--  -->
<template>
  <div class='Amap'>
    <div id="container"></div>
    <div id="tip">
      <input type="text" id="keyword" ref="keyword" name="keyword" value="" placeholder="请输入客户位置，选中提示搜索" />
      <!-- <button id="click" ref="clickme" >点我搜索</button> -->
    </div>
    <!-- <button @click="add">加点</button> -->
  </div>
</template>
<style>
.Amap {
  position: relative;
}
#tip {
  position: absolute;
  top: 20px;
  width: 100%;
  padding: 0 30px;
}
#tip input {
  width: 100%;
  height: 40px;
  border-radius: 3px;
  padding: 0 10px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.4);
}
</style>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import AMap from "AMap";
let Amap, marker,geocoder;
export default {
  //import引入的组件需要注入到对象中才能使用
  name: "map",
  components: {},
  data() {
    //这里存放数据
    return {
      address: {
        routes: "",
        tourRoutes: {
          province: "",
          city: "",
          longitude: "",
          latitude: "",
          name: "",
          orderNum: "",
          tourID: "",
        },
      },
      //center:[116.397428, 39.90923] //中心点坐标
    };
  },
  props: ["i",'center'],
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    add(capitals) {
      // let path = [new AMap.LngLat(116, 39), new AMap.LngLat(116, 40), new AMap.LngLat(117, 39)] //标准写法
      // // let polyline = new AMap.Polyline({
      // //     path: path,
      // // })
      // let markerList = path;
      // //Amap.add(polyline);
      // Amap.add(markerList)
      // marker = new AMap.Marker({
      //     position: [116.406315, 39.908775],
      // });
      // marker.setMap(Amap);
      // marker.setLabel({
      //     offset: new AMap.Pixel(20, 20), //设置文本标注偏移量
      //     content: "<div class='info'>我是 marker 的 label 标签</div>", //设置文本标注内容
      //     direction: 'right' //设置文本标注方位
      // });
      // let capitals = [
      //   {
      //     center: [116.524436, 39.923176],
      //     content: "<div class = 'area'>景点一</div>",
      //   },
      //   {
      //     center: [118.46947, 40.00212],
      //     content: "<div class = 'area'>景点二</div>",
      //   },
      //   {
      //     center: [112.324351, 35.96644],
      //     content: "<div class = 'area'>景点三</div>",
      //   },
      //   {
      //     center: [115.458678, 36.892771],
      //     content: "<div class = 'area'>景点四4</div>",
      //   },
      //   {
      //     center: [116.800742, 39.0],
      //     content: "<div class = 'area'>景点五</div>",
      //   },
      //   {
      //     center: [116.342891, 39.804469],
      //     content: "<div class = 'area'>景点六</div>",
      //   },
      //   {
      //     center: [116.525611, 40.737687],
      //     content: "<div class = 'area'>景点7</div>",
      //   },
      // ];
      // 创建一个 Marker 实例：
      for (let i = 0; i < capitals.length; i++) {
        marker = new AMap.Marker({
          position: capitals[i].center, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        });
        marker.setLabel({
          offset: new AMap.Pixel(10, 10), // 设置文本标注偏移量
          content: capitals[i].content, // 设置文本标注内容
          direction: "right", // 设置文本标注方位
        });
        marker.setMap(Amap);
      }

      let lineArr = new Array();
      capitals.map((val) => {
        lineArr.push(val.center);
      });
      //     }) lineArr.push(new AMap.LngLat(116.420087, 39.908374)); //第二个点
      // lineArr.push(new AMap.LngLat(116.432303, 39.909320)); //第三个点
      // lineArr.push(new AMap.LngLat(116.434679, 39.908769)); //第四个点
      // lineArr.push(new AMap.LngLat(116.434335, 39.924568)); //第五个点

      //绘制轨迹
      let polyline = new AMap.Polyline({
        // eslint-disable-line no-unused-vars
        path: lineArr,
        showDir: true,
        dirColor: "pink",
        strokeColor: "#3366bb", // 线颜色
        strokeWeight: 10,
      });
      Amap.add(polyline);
      Amap.setFitView();
      // alert("加点成功");
    },
    inputFocus() {
      this.$refs.keyword.focus();
    },
    getPositionByLonLats(lng, lat) {
        // console.log("经度："+lng+"纬度"+lat);
        var lnglat = [lng, lat];// 地图上所标点的坐标.
        let $this = this;
        console.log(lnglat)
        AMap.plugin(['AMap.Geocoder'],function(){
            geocoder = new AMap.Geocoder({});
            geocoder.getAddress(lnglat, function(status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    var address = result.regeocode.formattedAddress;
                    console.log(address);
                    let dian=[{
                      center: lnglat,
                      content: "<div class = 'area'>"+address+"</div>",
                    }]
                    let e={poi:{
                      //adcode: "430103",
                      address: address,
                      city: [],
                      district:"" ,
                      // id: "B0FFJ227QU",
                      location:  {lng: lng, lat: lat},
                      name: address,
                    }};
                    $this.markeradd(e)
                    document.getElementById('keyword').value=address
                } else {
                }
            });
        })
                
        
    },
    init() {
      let $this = this;
      Amap = new AMap.Map("container", {
        // eslint-disable-line no-unused-vars
        zoom: 11, //级别
        center: this.center, //中心点坐标
        mapStyle: "amap://styles/fresh",
        resizeEnable: true, //使用3D视图
      });
       // 创建一个 Icon
      let startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(25, 34),
        image: "//vdata.amap.com/icons/b18/1/2.png",
        // 图标所用图片大小
        imageSize: new AMap.Size(25, 25),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0),
      });
      let addmarker = new AMap.Marker({
        position: [this.center[0], this.center[1]],
        icon: startIcon,
      });
      //Amap.setCenter([this.mylng, this.mylat]); // 设置地图中心点
      addmarker.setMap(Amap);
      Amap.on("click",function(e){
          console.log(e.lnglat.getLng() + ',' + e.lnglat.getLat())
          $this.getPositionByLonLats(e.lnglat.getLng(),e.lnglat.getLat());
          
      })
      AMap.plugin(["AMap.Autocomplete", "AMap.PlaceSearch"], function () {
        let autoOptions = {
          input: "keyword",
          citylimit: true, // 使用联想输入的input的id
        };
        let autocomplete = new AMap.Autocomplete(autoOptions);
        // let placeSearch = new AMap.PlaceSearch({
        //     city: '北京',
        //     citylimit: true,
        //     autoFitView: false,
        //     map: Amap
        // })
        AMap.event.addListener(autocomplete, "select", function (e) {
          $this.markeradd(e)
        });

        // 通过点击按钮搜索 此功能暂时关闭 有需要开启
        // AMap.event.addDomListener(btn, "click", function(e) {
        //   console.log(autocomplete)
        //   placeSearch.search(autocomplete.d_);
        // });
        //   placeSearch.search(autocomplete, function (status, result) {
        //  // 查询成功时，result即对应匹配的POI信息
        //     console.log(result)
        //   })
        // placeSearch.search(e.poi.name)
        // placeSearch.search(e.poi.name)
      });
    },
    markeradd(e){
        let $this=this;
        if (this.addmarker) {
            this.addmarker.setMap(null);
            this.addmarker = null;
          }
          this.addmarker = new AMap.Marker({
            position: [e.poi.location.lng, e.poi.location.lat],
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
          });
          console.log(e);
          let detailedAddress = e.poi.district + e.poi.address;

          if (Array.isArray(e.poi.address)) {
            e.poi.address = e.poi.address[0];
          }
          $this.address.routes = detailedAddress;
          $this.address.tourRoutes.province = e.poi.district;
          $this.address.tourRoutes.city = e.poi.address;
          $this.address.tourRoutes.name = e.poi.name;
          $this.address.tourRoutes.longitude = e.poi.location.lng;
          $this.address.tourRoutes.latitude = e.poi.location.lat;
          $this.address.tourRoutes.orderNum = $this.i + 1;
          $this.$emit("getpoint", $this.address.tourRoutes, detailedAddress);
          console.log(
            $this.address.tourRoutes,
            detailedAddress,
            $this.address.routes
          );
          this.addmarker.setLabel({
            offset: new AMap.Pixel(20, 20), // 设置文本标注偏移量
            content: `<div class = 'area'>${detailedAddress}</div>`, // 设置文本标注内容
            direction: "right",
          });
          // document.querySelector(".amap-icon").style.width = "20px";
          Amap.setCenter([e.poi.location.lng, e.poi.location.lat]); // 设置地图中心点
          Amap.add(this.addmarker);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.init();
    this.inputFocus();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss" scoped>
#container {
  width: 100%;
  height: 100vh;
}

//@import url(); 引入公共css类
</style>
